import {
  cardOutline,
  receiptOutline,
  checkmarkOutline,
  bagHandleOutline,
  checkmarkDoneOutline,
} from 'ionicons/icons';
import type { OrderStatus } from '../../types/order';

// Shared step iconography + brand-color classes for the order-progress visuals.
// Both the single-order `OrderStatusBreadcrumb` (one order's live position) and
// the lister-facing `ListingOrderStepTally` (counts of orders sitting on each
// step) read from these maps so the two surfaces stay visually in lock-step.

export const STEP_ICON: Partial<Record<OrderStatus, string>> = {
  paid: cardOutline,
  received: receiptOutline,
  accepted: checkmarkOutline,
  ready_to_pickup: bagHandleOutline,
  completed: checkmarkDoneOutline,
};

/** Per-step brand color classes: bg, border, text, ring, and connector line. */
export const STEP_COLOR: Partial<
  Record<OrderStatus, { bg: string; border: string; text: string; ring: string; line: string }>
> = {
  paid: {
    bg: 'bg-brand-success',
    border: 'border-brand-success',
    text: 'text-brand-success',
    ring: 'ring-brand-success/30',
    line: 'bg-brand-success',
  },
  received: {
    bg: 'bg-brand-success',
    border: 'border-brand-success',
    text: 'text-brand-success',
    ring: 'ring-brand-success/30',
    line: 'bg-brand-success',
  },
  accepted: {
    bg: 'bg-brand-secondary',
    border: 'border-brand-secondary',
    text: 'text-brand-secondary',
    ring: 'ring-brand-secondary/30',
    line: 'bg-brand-secondary',
  },
  ready_to_pickup: {
    bg: 'bg-brand-tertiary',
    border: 'border-brand-tertiary',
    text: 'text-brand-tertiary',
    ring: 'ring-brand-tertiary/30',
    line: 'bg-brand-tertiary',
  },
  completed: {
    bg: 'bg-brand-primary',
    border: 'border-brand-primary',
    text: 'text-brand-primary',
    ring: 'ring-brand-primary/30',
    line: 'bg-brand-primary',
  },
};
